module.exports = __webpack_public_path__ + "static/media/tekura4.8898dc1d.jpg";